var _ellipse, _ellipse2, _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGalaxy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 607,
    height: 612,
    viewBox: "0 0 607 612",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 134.5,
    cy: 318,
    rx: 12.5,
    ry: 12,
    fill: "url(#paint0_radial_2_70)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 182.5,
    cy: 104,
    rx: 17.5,
    ry: 17,
    fill: "url(#paint1_radial_2_70)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M473 306C473 403.795 397.072 483 303.5 483C209.928 483 134 403.795 134 306C134 208.205 209.928 129 303.5 129C397.072 129 473 208.205 473 306Z",
    stroke: "url(#paint2_linear_2_70)",
    strokeOpacity: 0.2,
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M534 306C534 438.032 430.99 545 304 545C177.01 545 73.9999 438.032 73.9999 306C73.9999 173.968 177.01 67 304 67C430.99 67 534 173.968 534 306Z",
    stroke: "url(#paint3_linear_2_70)",
    strokeOpacity: 0.2,
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M606 306C606 474.455 470.558 611 303.5 611C136.442 611 0.999939 474.455 0.999939 306C0.999939 137.545 136.442 1 303.5 1C470.558 1 606 137.545 606 306Z",
    stroke: "url(#paint4_linear_2_70)",
    strokeOpacity: 0.2,
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_2_70",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(134.5 318) rotate(75.2319) scale(12.41 12.8612)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B69B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B06969",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_2_70",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(182.5 104) rotate(75.3982) scale(17.5674 18.0194)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B69B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B06969",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2_70",
    x1: 303.5,
    y1: 128,
    x2: 303.5,
    y2: 484,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E35030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#182255",
    stopOpacity: 0.06
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2_70",
    x1: 304,
    y1: 66,
    x2: 304,
    y2: 546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E35030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#182255",
    stopOpacity: 0.06
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2_70",
    x1: 303.5,
    y1: 0,
    x2: 303.5,
    y2: 612,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E35030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#182255",
    stopOpacity: 0.06
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGalaxy);
export default __webpack_public_path__ + "static/media/galaxy.ee4de752eb8a6d814698deb93ea02f7d.svg";
export { ForwardRef as ReactComponent };